module.exports = __webpack_public_path__ + "img/fig9.11.ea94225e.png";